import { styled } from '@mui/material/styles';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { Card } from 'shared/mui/Card';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';

export const StyledCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

export const CardHeaderStyled = styled(CardHeader, {
  shouldForwardProp: (prop) => prop !== 'isExpanded',
})<{ isExpanded?: boolean }>(({ theme, isExpanded }) => ({
  padding: '16px',
  ...(isExpanded && { borderBottom: `1px solid ${theme.palette.divider}` }),
}));

export const StyledLeftColumnBox = styled(Box)({
  width: '416px',
  minWidth: '416px',
  paddingRight: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const StyledRightColumnBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
  minWidth: '0',
  gap: '16px',
});

export const AlertStyled = styled(Alert)({
  height: '48px',
  margin: '16px',
});
